import {
  ActionIcon,
  Button,
  Modal,
  Pagination,
  Select,
  Skeleton,
  Table,
  Badge,
  Text,
  TextInput,
} from "@mantine/core";
import React, { useEffect, useState } from "react";
import { apiWrapWithErrorWithData } from "../utilities/apiHelpers";
import {
  getAgreementTypesApi,
  getObStatusForAg,
  updateObStatus,
} from "../utilities/apis/agreements";
import { Eye, Plus, SortAscending, SortDescending } from "tabler-icons-react";
import { getPartyNames } from "../utilities/apis/parties";
import { getBussinessUnit } from "../utilities/apis/serviceProvider";
import { formatIndianNumber, getObStatusText } from "../utilities/utilities";
import RelatedAgreementModal from "./AgreementsManager/agreementRelatedModal";

import { IconEdit, IconChecklist } from "@tabler/icons-react";
import { useSelector } from "react-redux";
import { selectUserData } from "../redux/selectors";
import { showNotification } from "@mantine/notifications";
import { getStatusColor, getStatusText } from "../utilities/enums";
import UniversalTable from "../components/Common/UniversalTable";
import TablePagination from "../components/Common/TablePagination";
import { Tooltip } from "@mantine/core";

const ObligationStatus = () => {
  const [agreements, setAgreeements] = useState([]);
  const [configs, setConfigs] = useState({
    loading: true,
    pageNumber: 1,
    pageSize: 10,
    count: 0,
  });
  const currentUser = useSelector(selectUserData) || {};
  const loginAs = currentUser.loginAs;
  const estampOption = [
    {
      label: "Yes",
      value: "Yes",
    },
    {
      label: "No",
      value: "No",
    },
  ];
  const [reload, setReload] = useState(false);
  const [filters, setFilters] = useState({});
  const [sortByOptions, setSortByOptions] = useState({
    key: "createdAt",
    value: "desc",
  });
  const handleKeyChange = (val) => {
    const newSortOption = { key: val, value: sortByOptions.value };
    setSortByOptions(newSortOption);
  };
  const toggleOrder = () => {
    const newSortOption = {
      key: sortByOptions.key,
      value: sortByOptions.value === "asc" ? "desc" : "asc",
    };
    setSortByOptions(newSortOption);
  };
  useEffect(() => {
    const getAgreements = async () => {
      const sortOption = { [sortByOptions.key]: sortByOptions.value };
      const response = await apiWrapWithErrorWithData(
        getObStatusForAg({
          pageNumber: configs.pageNumber,
          pageSize: configs.pageSize,
          filters: filters,
          sortBy: sortOption,
        }),
      );
      if (response.success) {
        setAgreeements(response.agreements);
        setConfigs({
          ...configs,
          loading: false,
          count: response.count,
        });
      }
    };
    getAgreements();
  }, [sortByOptions, configs.pageNumber, configs.pageSize, reload]);
  const [businessunitList, setbusinessunitList] = useState([]);
  const [parties, setParties] = useState(["secondparty"]);
  const [obStatusModal, setObStatusModal] = useState(false);
  const [obStatusId, setObStatusId] = useState(0);
  function handleCloseObModal() {
    setObStatusModal(false);
    setObStatusId(0);
  }
  const handleCloseModal = () => {
    // Set the showModal state to false when the modal is closed
    setShowModal(false);
  };
  const [showModalRelated, setShowModalRelated] = useState(false);
  const [relatedAgreementId, setRelatedAgreementId] = useState(null);
  const handlePlusClick = (id) => {
    console.log("id: ", id);
    setShowModalRelated(true);
    setRelatedAgreementId(id);
  };
  const handleCloseRelatedAgreementModal = () => {
    setShowModalRelated(false);
  };
  useEffect(() => {
    const fetchBusinessUnits = async () => {
      try {
        const { data } = await getBussinessUnit();
        if (data) {
          setbusinessunitList(data.businessunitList || []);
        } else {
          console.error("Invalid business unit response format:", response);
        }
      } catch (error) {
        console.error("Error fetching business units:", error);
      }
    };
    const getPartyName = async () => {
      const response = await apiWrapWithErrorWithData(getPartyNames());
      if (response.success) {
        console.log("party de rha h bro: ", response);
        setParties(response.parties);
      }
    };
    getPartyName();
    fetchBusinessUnits();
  }, []);
  const [agreementTypeOptions, setAgreementTypeOptions] = useState([]);
  const [transformedData, settransformedData] = useState([]);
  const getAgreementTypes = async () => {
    const resp = await apiWrapWithErrorWithData(getAgreementTypesApi());
    if (resp?.success && resp?.typesOfAgreement) {
      const uniqueValues = Array.from(new Set([...resp.typesOfAgreement]));
      const temp = uniqueValues.map((item) => ({ label: item, value: item }));
      setAgreementTypeOptions([...agreementTypeOptions, ...temp]);
    }
  };
  useEffect(() => {
    getAgreementTypes();
  }, []);
  useEffect(() => {
    if (businessunitList.length > 0) {
      settransformedData(
        businessunitList.map((unit) => ({
          value: unit.id + "",
          label: unit.name,
        })),
      );
    }
  }, [businessunitList]);
  const onViewClick = (agreementId) => {
    const url = `/app/agreements_manager/agreements/details/${agreementId}`;
    window.open(url, "_blank"); // '_blank' specifically tells the browser to open in a new tab/window
  };

  const handleNotRequired = async (req, res) => {
    const response = await apiWrapWithErrorWithData(
      updateObStatus({
        agreementId: obStatusId,
        obStatus: "not required",
      }),
    );
    if (response.success) {
      setObStatusId(0);
      setObStatusModal(false);
      showNotification({
        color: "green",
        title: "update obligation status",
        message: "obligation status updated",
      });
      setReload(!reload);
    }
  };

  const tableHeaders = [
    {
      label: "CIN",
      render: (row) => (
        <Text size="xs" weight={500}>
          {row.id}
        </Text>
      ),
    },
    {
      label: "TYPE",
      render: (row) => (
        <Text size="xs">
          {row.agreementData?.json?.typeOfAgreement || "--"}
        </Text>
      ),
    },
    {
      label: "JOB ORDER",
      render: (row) => <Text size="xs">{row.jobOrder || "--"}</Text>,
    },
    {
      label: "ACV",
      render: (row) => (
        <Text size="xs" weight={600}>
          {formatIndianNumber(row.agreementValue)}
        </Text>
      ),
    },
    {
      label: "SECOND PARTY",
      render: (row) => (
        <div className="flex flex-col">
          <Text size="xs" weight={500}>
            {row.agreementData?.json?.brandName || "N/A"}
          </Text>
          <Text size="10px" color="dimmed">
            {`(${row.agreementData?.json?.secondParty?.name || "-"})`}
          </Text>
        </div>
      ),
    },
    {
      label: "STATUS",
      render: (row) => (
        <Badge color={getStatusColor(row.status)} size="xs" variant="light">
          {getStatusText(row.status)}
        </Badge>
      ),
    },
    {
      label: "START DATE",
      render: (row) => (
        <Text size="xs">
          {row.contractStartDate ? row.contractStartDate.slice(0, 10) : "-"}
        </Text>
      ),
    },
    {
      label: "OBLIGATION STATUS",
      render: (row) => {
        const obStatus = getObStatusText(row.obligationStatus);
        return (
          <Badge color={obStatus.color} size="xs">
            {obStatus.text}
          </Badge>
        );
      },
    },
    {
      label: "ACTIONS",
      align: "right",
      render: (row) => (
        <div className="flex flex-row justify-end gap-2">
          {row.relationshipWith ? (
            <Tooltip label="Related Agreements">
              <ActionIcon
                variant="subtle"
                onClick={() => handlePlusClick(row.id)}
              >
                <Plus size={20} color="#1b6f8d" />
              </ActionIcon>
            </Tooltip>
          ) : (
            <Text size="xs" color="dimmed">
              --
            </Text>
          )}

          <Tooltip label="View Contract">
            <ActionIcon variant="subtle" onClick={() => onViewClick(row.id)}>
              <Eye size={20} color="#1b6f8d" />
            </ActionIcon>
          </Tooltip>

          {loginAs?.id === 4 && (
            <Tooltip label="Mark Obligation as Not Required">
              <ActionIcon
                variant="subtle"
                color="orange"
                disabled={
                  row.obligationStatus !== "NA" ||
                  row.obligationStatus === "not required"
                }
                onClick={() => {
                  setObStatusId(row.id);
                  setObStatusModal(true);
                }}
              >
                <IconChecklist size={20} />
              </ActionIcon>
            </Tooltip>
          )}
        </div>
      ),
    },
  ];
  return (
    <div>
      {showModalRelated && (
        <Modal
          overflow="inside"
          opened
          onClose={handleCloseRelatedAgreementModal} // Call the handler on modal close
          size="calc(80vw)"
        >
          <RelatedAgreementModal agreementId={relatedAgreementId} />
        </Modal>
      )}
      <Modal opened={obStatusModal} onClose={handleCloseObModal}>
        <div>
          <Text size="sm">
            This action will permanently mark the obligation status as
            <strong> "Not Required"</strong>.
            <br />
            <br />
            Are you sure you want to continue?
          </Text>
          <div className="flex justify-between mt-4">
            <Button variant="outline" onClick={handleCloseObModal}>
              Cancel
            </Button>
            <Button onClick={handleNotRequired}>Not Required</Button>
          </div>
        </div>
      </Modal>
      
      <div className="dashboard-header">
        <div>
          <h1 className="dashboard-heading">Obligations Status</h1>
          <p className="dashboard-subtitle">
            View all the contracts with status of obligation
          </p>
        </div>
      </div>

      {configs.loading && (
        <div className="flex flex-col">
          {Array.from({ length: 10 }).map((i) => (
            <Skeleton key={i} height={30} radius="md" className="my-1 w-full" />
          ))}
          <div className="flex flex-row justify-center">
            <Skeleton height={40} radius="md" className="w-40" />
          </div>
        </div>
      )}
      {!configs.loading && agreements && (
        <>
          <div className="flex w-full justify-between items-center">
            <div className="flex flex-col">
              <div className="flex flex-row-sm">
                {/* <Text size="xs" className="mb-2" color="gray">
                    Case sensitive search
                  </Text> */}
                <div className="flex items-center">
                  {/* <TextInput
                      value={listing.searchString}
                      onChange={(input) => {
                        const val = getValueForInput(input);
                        setListing((prevState) => ({
                          ...prevState,
                          searchString: val,
                        }));
                      }}
                      placeholder="Type to search..."
                      icon={<Search size={14} />}
                    /> */}

                  {/* <Select
                    className="mx-2"
                    placeholder="estamp"
                    value={filters.estamp || null}
                    onChange={(val) => {
                      setFilters((prevState) => ({
                        ...prevState,
                        estamp: val,
                      }));
                    }}
                    data={estampOption}
                    style={{ minWidth: "228px" }}
                  /> */}
                  <Select
                    className="mx-2"
                    placeholder="Select Obligation Status"
                    value={filters.obligationStatus || null}
                    onChange={(val) => {
                      setFilters((prevState) => ({
                        ...prevState,
                        obligationStatus: val,
                      }));
                    }}
                    data={[
                      { label: "Pending", value: "NA" },
                      { label: "Created", value: "created" },
                      { label: "Not Required", value: "not required" },
                    ]}
                    style={{ minWidth: "228px" }}
                  />
                  <Select
                    className="mx-2"
                    placeholder="Select Business Unit"
                    value={filters.mapBusinessunit || null}
                    data={transformedData}
                    onChange={(value) => {
                      setFilters((prevState) => ({
                        ...prevState,
                        mapBusinessunit: value,
                      }));
                    }}
                    style={{ minWidth: "228px" }}
                  />
                  <TextInput
                    className="mx-2"
                    placeholder="Enter Job Order"
                    value={filters?.jobOrder?.contains || null}
                    onChange={(e) =>
                      setFilters((preState) => ({
                        ...preState,
                        jobOrder: { contains: e.target.value },
                      }))
                    }
                    maw={400}
                    mx="auto"
                    style={{ minWidth: "228px" }}
                  />
                  <Select
                    className="mx-2"
                    // value={filters.partyName || null}
                    onChange={(value) => {
                      // const val = getValueForInput(input);
                      setFilters((prevState) => ({
                        ...prevState,
                        OR: [
                          {
                            secondParty: {
                              path: "$.name",
                              string_contains: value,
                              // mode: "insensitive",
                            },
                          },
                          {
                            secondParty: {
                              path: "$.brandName",
                              string_contains: value,
                            },
                          },
                        ],
                      }));
                    }}
                    placeholder="Select Party"
                    type="text"
                    searchable
                    data={parties}
                    style={{ minWidth: "228px" }}
                  />
                </div>
              </div>
            </div>
          </div>
          <br />
        </>
      )}
      <Button
        className="mx-2"
        variant="outline"
        onClick={() => setReload(!reload)}
      >
        Search
      </Button>
      <Button
        className="mx-2"
        variant="contained"
        onClick={() => {
          // setFilters({}), setReload(!reload);
          window.location.reload();
        }}
      >
        Clear
      </Button>
      {/* <div className="flex float-right">
        <div className="flex">
          <Select
            value={sortByOptions.key}
            onChange={(val) => handleKeyChange(val)}
            data={[
              { label: "created at", value: "createdAt" },
              { label: "end date", value: "dueDateOfContract" },
              { label: "contract type", value: "typeOfAgreement" },
              { label: "ain", value: "id" },
              { label: "contarct value", value: "agreementValue" },
            ]}
          />
          <ActionIcon className="mx-2" onClick={toggleOrder}>
            {sortByOptions.value === "asc" ? (
              <SortAscending size={32} />
            ) : (
              <SortDescending size={32} />
            )}
          </ActionIcon>
        </div>
      </div> */}

      {!configs.loading && agreements && (
        <>
          <UniversalTable
            headers={tableHeaders}
            data={agreements || []}
            loading={configs.loading}
            emptyMessage="No contracts found"
          />

          <TablePagination
            totalCount={configs.count}
            page={configs.pageNumber}
            pageSize={configs.pageSize}
            onPageChange={(page) =>
              setConfigs({
                ...configs,
                pageNumber: page,
              })
            }
            onPageSizeChange={(val) =>
              setConfigs({
                ...configs,
                pageSize: parseInt(val),
                pageNumber: 1, // Reset to page 1 on size change
              })
            }
            dataLength={agreements?.length || 0}
          />
        </>
      )}
      {!configs.loading && !agreements?.length ? (
        <div
          className="flex justify-center items-center"
          style={{
            minHeight: "300px",
          }}
        >
          No contracts
        </div>
      ) : null}
      {/* </div> */}
    </div>
  );
};

export default ObligationStatus;
